import { z } from 'zod';

export const campaignPayloadSchema = z.object({
  id: z.number(),
  name: z.string(),
  start_date: z.string(),
  end_date: z.string(),
  slug: z.string(),
  lci_lift_percentage: z.number().nullable(),
  vr_total_visits: z.number().nullable(),
  advertiser_team_id: z.number(),
  advertiser_team_name: z.string(),
  ad_spend: z.number().nullable().optional(),
  budget: z.number(),
  impressions: z.number().nullable(),
  latest_stat_date: z.string().nullable(),
  latest_report_updated_date: z.string().nullable(),
  xdv: z.boolean(),
  measurement_status: z.union([
    z.literal('approved'),
    z.literal('approved_visit_metrics'),
    z.literal('pending'),
  ]),
  custom_reports: z.array(z.object({ id: z.number(), name: z.string() })),
  partner: z.string().nullable(),
  report_id: z.number().nullable(),
  report_group: z.string().nullable(),
  approved_report_dates: z.array(z.object({ report_date: z.string() })),
  lci_sales_lift_flag: z.boolean(),
  sales_attribution_requested: z.boolean(),
  lci_version_id: z.number().nullable(),
  large: z.boolean(),
});

const _campaignSchema = z.object({
  id: z.number(),
  name: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  lciVersionId: z.number(),
  measurementStatus: z.union([
    z.literal('approved'),
    z.literal('approved_visit_metrics'),
    z.literal('pending'),
  ]),
  budget: z.number(),
  adSpend: z.number().optional(),
  latestReportUpdatedDate: z.string(),
  latestStatDate: z.string(),
  salesLiftEnabled: z.boolean(),
  salesLiftRequested: z.boolean(),
});

export type CampaignSchema = z.infer<typeof _campaignSchema>;
export type CampaignPayload = z.infer<typeof campaignPayloadSchema>;
